export enum FlowState {
	Start = 0,
	Middle = 1,
	End = 2
}
